import Phaser from 'phaser';
import RexUIPlugin from 'phaser3-rex-plugins/templates/ui/ui-plugin';

import PluginKeys from './constants/PluginKeys';
import BattlePreloaderScene from './scenes/BattlePreloader';
import BattleScene from './scenes/Battle';

const LemonLegends = {
  type: Phaser.AUTO,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 1280,
    height: 720,
  },
  pixelArt: true,
  scene: [BattlePreloaderScene, BattleScene],
  plugins: {
    scene: [
      {
        key: PluginKeys.RexUI,
        plugin: RexUIPlugin,
        mapping: PluginKeys.RexUI,
      },
    ],
  },
};

export default LemonLegends;
